export default __webpack_public_path__ + "static/users-map-59a5d8b4e61b86b58eb90f3fe88024de.svg";